export enum AdpVoucherPrintStatus {    
    WaitingConsentFile = -3,
    WaitingScreeningFile = -2,
    WaitingSwabFile = -1,
    ReadyToPrint = 0,
    Printed = 1,
    MarkSentUser1 = 2,
    MarkSentUser2 = 3
}